<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>
<p-confirmDialog [style]="{width: '450px'}" [acceptLabel]="translate('Yes')" [rejectLabel]="translate('No')"></p-confirmDialog>

<ng-container *ngIf="noRequest && !requestForm && permissions.length <=0 && (this.hasPermissionRequest() || hasPermission('PERMISSION_REQUESTS', 'c')) && !isLoading ">
  <div class="container-fluid">
    <div class="d-flex justify-content-center">
      <div class="b-i-box-flex">
        <div class="b-i-box">
          <i class="pi pi-check-square font-2"></i>
        </div>
        <p class="b-i-box-text">{{'Currently, there are no permissions available in the system. To proceed, please create a new permission by clicking the button below. This will allow you to define the access or actions required for your process.' | translator}}</p>
        <div class="flex justify-content-center">
          <div class="d-flex">
            <div class="v4-btn-every m-1" (click)="router.navigate(['/home'])"><i
                class="pi pi-arrow-right m-l-2"></i>{{'Cancel' | translator}}</div>
            <div class="v4-btn-every m-1" (click)="createNewPermission()">{{'Request Permission' | translator}}<i
                class="pi pi-arrow-left m-r-2"></i></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>


<div *ngIf="!requestForm" class="container-fluid">
  <div class="content-grey mb-4" *ngIf="hasPermission('PERMISSION_REQUESTS', 'c') || this.hasPermissionRequest()">
      <button pButton type="button"   icon="pi pi-plus" [label]="translate('Request Permission')" class="v4-btn-every m-1"
        (click)="createNewPermission()">
      </button>
  </div>


  <!-- Filter Section -->
  <div class="content-grey mb-4">
    <div class="row p-0">
      <!-- Organizational Unit Filter -->
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/apartment.png" alt="organization">
            <label class="label-ui">{{'Organizational Unit' | translator}}</label>
          </div>
          <div>
            <p-treeSelect class="v4-tree my-2"  (onNodeSelect)="getPermissions()" containerStyleClass="pppp-tree w-100"
              [options]="selectedTreeData" appendTo="body" [(ngModel)]="ouFilter"
              placeholder="{{ 'Choose the organizational unit' | translator }}" [filter]="true"
              [filterInputAutoFocus]="true">
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                    class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label }}</b>
                </div>
              </ng-template>
            </p-treeSelect>
          </div>
        </div>
      </div>
 <!-- Manager Filter -->
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/account_circle.png" alt="manager">
            <label class="label-ui">{{'Manager' | translator}}</label>
          </div>
          <div>
            <p-dropdown class="ppp-dropdown" [options]="contentUpdateUsers" [(ngModel)]="managerFilter"
              [placeholder]="translate('Select Manager')"  optionLabel="name" styleClass="w-100"
              (onChange)="getPermissions()">
            </p-dropdown>
          </div>
        </div>
      </div>
 
      <!-- Status Filter -->
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/status.png" alt="status">
            <label class="label-ui">{{'Status' | translator}}</label>
          </div>
          <div>
            <p-dropdown class="ppp-dropdown" [options]="[
                { label: translate('Pending'), value: { e: 'PENDING' } },
                { label: translate('Approved'), value: { e: 'APPROVED' } },
                { label: translate('Rejected'), value: { e: 'REJECTED' } }
              ]" [(ngModel)]="statusFilter" [placeholder]="translate('Select Status')" 
              optionLabel="label" styleClass="w-100" (onChange)="getPermissions()">
            </p-dropdown>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="date">
            <label class="label-ui">{{'Date' | translator}}</label>
          </div>
          <div class="d-flex">
            <div>
              <p-calendar class="ppp-calander" [(ngModel)]="dateRange" selectionMode="range" [showButtonBar]="true"
                 [placeholder]="translate('Select Date Range')" styleClass="w-100"
                (onSelect)="getPermissions()">
              </p-calendar>
            </div>
          <div class="mx-2">
            <button class="v4-btn-every m-1" (click)="clearFilters()"><i
              class="pi pi-filter-slash m-l-2"></i>{{translate('Clear')}}</button>
          </div>
        
        </div>
        </div>
      </div>

    </div>
  </div>

  

  <!-- Old button code (commented) -->
  <!-- <div class="d-flex justify-content-end mb-4" *ngIf="hasPermission('PERMISSION_REQUESTS', 'c')">
    <button pButton type="button" icon="pi pi-plus" [label]="translate('Create Request')" class="p-button-primary"
      (click)="requestForm = true">
    </button>
  </div> -->

  <div class="tab-bg">
    <div class="mask">
      <div> 
        <div *ngIf="isLoading" class="loading-container">
          <p-progressSpinner 
            [style]="{width: '50px', height: '50px'}" 
            strokeWidth="4" 
            fill="var(--surface-ground)" 
            animationDuration=".5s">
          </p-progressSpinner>
        </div>

        <table *ngIf="!isLoading">
          <thead>
            <tr>
              <th>
                <div class="d-flex align-items-center">
                  <div>#</div>
                  <div class="w-20px">
                    <!-- {{'Organizational units' | translator}} -->
                  </div>
                  <div class="">
                    {{'Contact officer name' | translator}}
                  </div>
              </div>
            </th>
              <th>{{'Question Maker' | translator}}</th>
              <th>{{'From' | translator}}</th>
              <th>{{'To' | translator}}</th>
              <th>{{'Type' | translator}}</th>
              <th>
                <div class="d-flex">
                  <div class="w-10px">{{'Status' | translator}}</div>
                  <div class="">{{'Actions' | translator}}</div>

                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let permission of permissions;let i = index ">
              <tr>
                <td>
                  <div class="d-flex align-items-center w-100">
                    <div class="d-flex">
                      <div class="tab-num">{{i + 1}}</div>
                    </div>
                    <div class="td-200-px">
                      <div class="d-flex align-items-center">
                        <div class="tab-pos-rel">
                          <!-- Show only last 4 images -->
                          <ng-container *ngFor="let ou of permission?.generalData?.ou.slice(-4); let j=index">
                            <div class="position-relative">
                              <img *ngIf="checkisImg(ou.image); else elseBlock" 
                                class="{{'tab-pos-img-'+(j+1)}} bg-white"
                                src="{{ staticURL }}{{ ou.image }}" 
                                alt="loading...">
                              <ng-template #elseBlock>
                                <i class="{{ ou.image }} p-2" style="font-size: 1rem"></i>
                              </ng-template>
                              <div *ngIf="j === 0 && permission?.generalData?.ou.length > 4" 
                                class="position-absolute top-0 start-0 bg-dark text-white rounded-circle p-1"
                                style="font-size: 0.7rem; margin: -5px 0 0 -5px;">
                                +{{permission?.generalData?.ou.length - 4}}
                              </div>
                            </div>
                          </ng-container>
                        </div>
                       
                        <div class="tab-mini-num-container">
                          <div class="tab-mini-num">{{permission?.generalData?.ou?.length || 0}}</div>
                        </div>
                        
                        {{permission.contactOfficer.employeeName}}
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="tab-grey-box">
                    <div class="d-flex">
                      <img class="tab-icone" src="../../../../assets/icones-2025/account_circle.png" alt="manager">
                    </div>
                    <div class="td-100-px">{{permission.questionMaker.employeeName}}</div>
                  </div>
                </td>
                <td>
                  <div class="d-flex gap-10">
                    <div class="tab-grey-box-2">
                      <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="calendar">
                      <div>{{getMinMaxDates(permission.testEntries).minDate | date:'dd-MM-yyyy'}}</div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="tab-arrow">
                        <img class="tab-icone-2" src="../../../../assets/icones-2025/arrow_cool_down.png" alt="arrow">
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex gap-10">
                    <div class="tab-grey-box-2">
                      <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="calendar">
                      <div>{{getMinMaxDates(permission.testEntries).maxDate | date:'dd-MM-yyyy'}}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="tab-grey-box-2 d-flex align-items-center">
                    <div class="tab-gery-box">
                      <div class="request-type-label" style="min-width: 100px; text-align: center;">{{permission.generalData.requestFor?.name | translator}}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-content-between gap-10">
                    <!-- For APPROVED/REJECTED status -->
                    <ng-container *ngIf="permission.status === 'APPROVED' || permission.status === 'REJECTED'">
                      <div class="d-flex">
                        <div class="border-left">
                          <div class="tab-grey-box-green" [ngClass]="{
                            'status-approved': permission.status === 'APPROVED',
                            'status-rejected': permission.status === 'REJECTED'
                          }">
                            <div>{{permission.status| translator}}</div>
                          </div>
                        </div>
                        <button class="thumb-btn" (click)="togglePermissionDetails(permission._id)">
                          <i class="pi pi-chevron-down thumb-icon" [class.rotated]="isPermissionExpanded(permission._id)"></i>
                        </button>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="permission.status !== 'APPROVED' && permission.status !== 'REJECTED'">
                      <div class="d-flex">
                        <div class="border-left">
                          <div class="tab-grey-box-green status-pending">
                            <div>{{permission.status | translator}}</div>
                          </div>
                        </div>
                        <button class="thumb-btn" (click)="togglePermissionDetails(permission._id)">
                          <i class="pi pi-chevron-down thumb-icon" [class.rotated]="isPermissionExpanded(permission._id)"></i>
                        </button>
                      </div>
                    </ng-container>

                    <!-- Action buttons grouped on right -->
                    <div class="d-flex align-items-center">
                      <!-- Eye button for viewing details -->
                      <div class="plus-btn mx-2" (click)="$event.stopPropagation(); openPermissionForm(permission._id)">
                        <i class="pi pi-eye" style="font-size: 0.9rem"></i>
                      </div>
                      <!-- Delete button - only for PENDING status -->
                      <div *ngIf="permission.status === 'PENDING'" 
                           class="plus-btn mx-2" 
                           (click)="$event.stopPropagation(); deletePermission(permission._id)"
                           style="cursor: pointer;">
                        <i class="pi pi-trash" style="font-size: 0.9rem; color: #ffffff;"></i>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="isPermissionExpanded(permission._id)">
                <td colspan="100%">
                  <div class="tab-external-ui w-100">
                    <!-- For APPROVED or REJECTED status -->
                    <ng-container *ngIf="permission.status === 'APPROVED' || permission.status === 'REJECTED'">
                      <!-- Test Goal -->
                      <!-- <div class="d-flex align-items-center gap-2 mb-3">
                        <div class="tab-grey-box-2">
                          <i class="pi pi-info-circle color-grey"></i>
                          <div>{{permission.testGoal}}</div>
                        </div>
                      </div> -->
                      <div class="row p-0">
                        <div class="col-md-9 col-12 d-flex align-items-start justify-content-center flex-column">
                          
                          <!-- Assessments Section -->
                          <div *ngIf="permission.assessments && permission.assessments.length > 0">
                            <div *ngFor="let assessment of permission.assessments">
                              <div class="d-flex align-items-center gap-2 my-2">
                                <!-- Assessment Name -->
                                <div class="color-grey w-30px">{{assessment.name}}</div>
                                
                                <!-- Assessment Date -->
                                <div class="d-flex gap-10">
                                  <div class="tab-grey-box-2">
                                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="calendar">
                                    <div>{{assessment.startDate?.substring(0,10)}}</div>
                                  </div>
                                </div>
      
                                <!-- Assessment Time -->
                                <div>
                                  <div class="tab-grey-box-2">
                                    <i class="pi pi-clock color-grey"></i>
                                    <div>{{assessment.startDate?.substring(11,16)}}</div>
                                    <i class="pi pi-stopwatch color-grey"></i>
                                    <div>{{assessment.endDate?.substring(11,16)}}</div>
                                  </div>
                                </div>
      
                                <!-- Action Buttons -->
                                <div>
                                  <div class="d-flex align-items-center">
                                    <div class="d-flex gap-2">
                                      <!-- View/Edit Questions Button -->
                                      <div class="plus-btn" (click)="navigateToSurvey({assessmentId: assessment._id}, permission._id)" title="{{'View/Edit Questions' | translator}}">
                                        <i class="pi pi-eye" style="font-size: 0.9rem"></i>
                                      </div>
                                      
                                      <!-- Menu for additional actions -->
                                      <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
                                      <div class="plus-btn" (click)="openPermissionMenu(menu, $event, permission, {assessmentId: assessment._id, type: 'ASSESSMENT'})" title="{{'More Actions' | translator}}">
                                        <i class="pi pi-ellipsis-v" style="font-size: 0.9rem"></i>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Surveys Section -->
                          <div *ngIf="permission.surveys && permission.surveys.length > 0">
                            <div *ngFor="let survey of permission.surveys">
                              <div class="d-flex align-items-center gap-2 my-2">
                                <!-- Survey Name -->
                                <div class="color-grey w-30px">{{survey.name}}</div>
                                
                                <!-- Survey Date -->
                                <div class="d-flex gap-10">
                                  <div class="tab-grey-box-2">
                                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="calendar">
                                    <div>{{survey.startDate?.substring(0,10)}}</div>
                                  </div>
                                </div>
      
                                <!-- Survey Time -->
                                <div>
                                  <div class="tab-grey-box-2">
                                    <i class="pi pi-clock color-grey"></i>
                                    <div>{{survey.startDate?.substring(11,16)}}</div>
                                    <i class="pi pi-stopwatch color-grey"></i>
                                    <div>{{survey.endDate?.substring(11,16)}}</div>
                                  </div>
                                </div>
      
                                <!-- Action Buttons -->
                                <div>
                                  <div class="d-flex align-items-center">
                                    <div class="d-flex gap-2">
                                      <!-- View/Edit Questions Button -->
                                      <div class="plus-btn" (click)="navigateToSurvey({surveyId: survey._id}, permission._id)" title="{{'View/Edit Questions' | translator}}">
                                        <i class="pi pi-eye" style="font-size: 0.9rem"></i>
                                      </div>
                                      
                                      <!-- Menu for additional actions -->
                                      <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
                                      <div class="plus-btn" (click)="openPermissionMenu(menu, $event, permission, {surveyId: survey._id, type: 'SURVEY'})" title="{{'More Actions' | translator}}">
                                        <i class="pi pi-ellipsis-v" style="font-size: 0.9rem"></i>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Fallback to testEntries if no assessments or surveys -->
                          <div *ngIf="(!permission.assessments || permission.assessments.length === 0) && (!permission.surveys || permission.surveys.length === 0)">
                            <div *ngFor="let test of permission.testEntries">
                              <div class="d-flex align-items-center gap-2 my-2">
                                <!-- Test Name -->
                                <div class="color-grey w-30px">{{test.testName}}</div>
                                
                                <!-- Test Date -->
                                <div class="d-flex gap-10">
                                  <div class="tab-grey-box-2">
                                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="calendar">
                                    <div>{{test.testDate}}</div>
                                  </div>
                                </div>
      
                                <!-- Test Time -->
                                <div>
                                  <div class="tab-grey-box-2">
                                    <i class="pi pi-clock color-grey"></i>
                                    <div>{{test.startTime}}</div>
                                    <i class="pi pi-stopwatch color-grey"></i>
                                    <div>{{test.endTime}}</div>
                                  </div>
                                </div>
      
                                <!-- Action Buttons -->
                                <div>
                                  <div class="d-flex align-items-center">
                                    <ng-container *ngIf="test.surveyId || test.assessmentId">
                                      <div *ngIf="!getTestData(test)" class="spinner-border spinner-border-sm text-primary" role="status">
                                        <span class="visually-hidden">{{'Loading...' | translator}}</span>
                                      </div>
                                      <div *ngIf="getTestData(test)" class="d-flex gap-2">
                                        <!-- View/Edit Questions Button -->
                                        <div class="plus-btn" (click)="navigateToSurvey(test,permission._id)" title="{{'View/Edit Questions' | translator}}">
                                          <i class="pi pi-eye" style="font-size: 0.9rem"></i>
                                        </div>
                                        
                                        <!-- Menu for additional actions -->
                                        <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
                                        <div class="plus-btn" (click)="openPermissionMenu(menu, $event, permission, {testId: test._id, type: test.surveyId ? 'SURVEY' : 'ASSESSMENT'})" title="{{'More Actions' | translator}}">
                                          <i class="pi pi-ellipsis-v" style="font-size: 0.9rem"></i>
                                        </div>
                                      </div>
                                    </ng-container>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                          <div class="col-md-3 col-12">
                            <!-- Comments Section -->
                            <div class="d-flex align-items-center gap-2 mb-3 h-100">
                              <div class="tab-grey-box-comment">
                                <i class="pi pi-comments color-grey"></i>
                                <div class="break-txt">{{permission.comments || ('No comments provided' | translator)}}</div>
                              </div>
                            </div>
                          </div>
                      </div>
                      
                    </ng-container>

                    <!-- For other statuses -->
                    <ng-container *ngIf="permission.status !== 'APPROVED' && permission.status !== 'REJECTED'">
                       <!-- Test Goal -->
                       <!-- <div class="d-flex align-items-center gap-2 mb-3">
                        <div class="tab-grey-box-2">
                          <i class="pi color-grey">Goal</i>
                          <div>{{permission.testGoal}}</div>
                        </div>
                      </div> -->
                      <div *ngFor="let test of permission.testEntries">
                        <div class="d-flex align-items-center gap-2 my-2">
                          <div class="color-grey w-30px">{{test.testName}}</div>
                          <div class="d-flex gap-10">
                            <div class="tab-grey-box-2">
                              <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="calendar">
                              <div>{{test.testDate}}</div>
                            </div>
                          </div>
                          <div>
                            <div class="tab-grey-box-2">
                              <i class="pi pi-clock color-grey"></i>
                              <div>{{test.startTime}}</div>
                              <i class="pi pi-stopwatch color-grey"></i>
                              <div>{{test.endTime}}</div>
                            </div>
                          </div>
                          <div>
                            <div class="d-flex align-items-center">
                              <ng-container *ngIf="test.surveyId || test.assessmentId">
                                <div *ngIf="!getTestData(test)" class="spinner-border spinner-border-sm text-primary" role="status">
                                  <span class="visually-hidden">{{'Loading...' | translator}}</span>
                                </div>
                                <div *ngIf="getTestData(test)" class="d-flex gap-2">
                                  <!-- View/Edit Questions Button -->
                                  <div class="plus-btn" (click)="navigateToSurvey(test,permission._id)" title="{{'View/Edit Questions' | translator}}">
                                    <i class="pi pi-eye" style="font-size: 0.9rem"></i>
                                  </div>
                                  
                                  <!-- Menu for additional actions -->
                                  <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
                                  <div class="plus-btn" (click)="openPermissionMenu(menu, $event, permission, {testId: test._id, type: test.surveyId ? 'SURVEY' : 'ASSESSMENT'})" title="{{'More Actions' | translator}}">
                                    <i class="pi pi-ellipsis-v" style="font-size: 0.9rem"></i>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </td>
              </tr>

            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Add Pagination -->
  <div class="mx-2 d-flex justify-content-center 111">
    <p-paginator [rows]="rows" [totalRecords]="totalCount" [rowsPerPageOptions]="[10, 20, 30, 50]"
      [showCurrentPageReport]="true" (onPageChange)="onPageChange($event)" [first]="first">
    </p-paginator>
  </div>
</div>






<!-- content start -->
<!-- <div class="content-grey">


  <div class="row p-0">

  
    <div class="col-lg-2 col-md-6 col-12">
      <div class="d-flex flex-column">
        <div class="d-flex my-2">
          <img class="filter-brightness" src="../../../../assets/icones-2025/apartment.png" alt="organization">
          <label class="label-ui">Organizational unit</label>
        </div>
        <div>
          <input class="input-ui" type="name" placeholder="name">
        </div>
      </div>
    </div>

    <div class="col-lg-2 col-md-6 col-12">
      <div class="d-flex flex-column">
        <div class="d-flex my-2">
          <img class="filter-brightness" src="../../../../assets/icones-2025/apartment.png" alt="organization">
          <label class="label-ui">Organizational unit</label>
        </div>
        <div>
          <input class="input-ui" type="name" placeholder="name">
        </div>
      </div>
    </div>

    <div class="col-lg-3 col-md-6 col-12">
      <div class="d-flex flex-column">
        <div class="d-flex my-2">
          <img class="filter-brightness" src="../../../../assets/icones-2025/apartment.png" alt="organization">
          <label class="label-ui">Organizational unit</label>
        </div>
        <div>
          <div class="tab-grey-box-new">
            <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="calendar">
            <div>15-02-2024</div>
            <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="schedule">
            <div>09:00 AM</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-3 col-md-6 col-12">
      <div class="d-flex flex-column">
        <div class="d-flex my-2">
          <img class="filter-brightness" src="../../../../assets/icones-2025/apartment.png" alt="organization">
          <label class="label-ui">Organizational unit</label>
        </div>
        <div>
          <div class="tab-grey-box-new">
            <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="calendar">
            <div>15-02-2024</div>
            <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="schedule">
            <div>09:00 AM</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="d-flex flex-column">
        <div class="d-flex my-2">
          <img class="filter-brightness" src="../../../../assets/icones-2025/apartment.png" alt="organization">
          <label class="label-ui">Organizational unit</label>
        </div>
        <div>
          <div class="d-flex flex-wrap">
            <div class="blue-num-btn">
              <div class="d-flex">
                <div class="btn-num m-l-2">
                  <i class="pi pi-plus color-blue"></i>
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>

            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <img class="grey-num-btn-img" src="../../assets/Ministry-of-culture.png" alt="draft">
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>

            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <img class="grey-num-btn-img" src="../../assets/Ministry-of-Defense.png" alt="draft">
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>

            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <img class="grey-num-btn-img" src="../../assets/Ministry-of-culture.png" alt="draft">
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>

            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <img class="grey-num-btn-img" src="../../assets/Ministry-of-Defense.png" alt="draft">
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <div class="col-lg-12">
      <div class="d-flex flex-column">
        <div class="d-flex my-2">
          <img class="filter-brightness" src="../../../../assets/icones-2025/apartment.png" alt="organization">
          <label class="label-ui">Organizational unit</label>
        </div>
        <div>
          <div class="d-flex flex-wrap">
            
            <div class="grey-num-btn-active">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <p-radioButton name="typeFlag" ></p-radioButton>
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>

            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <p-radioButton name="typeFlag" ></p-radioButton>
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>
            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <p-radioButton name="typeFlag" ></p-radioButton>
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>
            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <p-radioButton name="typeFlag" ></p-radioButton>
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>
            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <p-radioButton name="typeFlag" ></p-radioButton>
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>
            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <p-radioButton name="typeFlag" ></p-radioButton>
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>
            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <p-radioButton name="typeFlag" ></p-radioButton>
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>
            <div class="grey-num-btn">
              <div class="d-flex">
                <div class="d-flex align-items-center m-l-2">
                  <p-radioButton name="typeFlag" ></p-radioButton>
                </div>
              </div>
              <div class="d-flex">
                <label>Policies</label>
              </div>
            </div>
            
            </div>

          </div>
        </div>
      </div>
    </div>



   
    <div class="content-white">
      <p class="label-ui">Have all the organization data been reviewed on the knowledge portal?</p>
      <div class="d-flex">
        <div class="yes-btn">
          <div class="d-flex">
            <label>Yes</label>
          </div>
        </div>
        <div class="no-btn">
          <div class="d-flex">
            <label>No</label>
          </div>
        </div>
      </div>
    </div>

   
    <div class="content-white">
      <p class="label-ui">Please add comments</p>
      <div class="form-floating">
        <textarea class="form-control custom-textarea" placeholder="Leave a comment here" id="floatingTextarea2"
          style="height: 100px"></textarea>
      </div>
    </div>

   
    <div class="content-white">
      <p class="label-ui">Please confirm</p>
      <div class="text-radio-bar">
        <div class="d-flex">
          <input class="form-check-input" type="checkbox" name="agreement">
        </div>
        I agree to the terms and conditions
      </div>
    </div>

   
    <div class="d-flex">
      <div class="submit-blue-btn">
        <div class="d-flex align-items-center">
          <img src="../../../../assets/icones-2025/check_small.png" alt="submit">
        </div>
        Submit
      </div>
    </div>

  </div> -->

<!-- content end -->

<div class="content-grey" *ngIf="requestForm">
  <div class="d-flex mb-4">
    <div class="back-btn" (click)="requestForm = false">
      <div class="v4-btn-every">
        <i class="pi pi-arrow-right m-l-2"></i>{{'Back' | translator}}
      </div>
    </div>
  </div>
  <app-permission-requests-form [permissionId]="selectedPermissionId" [isViewMode]="isViewing"></app-permission-requests-form>
</div>

<!-- Update Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="updateModal"
  (onHide)="onDialogClose()" [style]="{ margin: '0rem 1rem' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ updateData?.testType === 'ASSESSMENT' ? ('Update Assessment' | translator) : ('Update Survey' | translator) }}</span>
  </ng-template>
  <app-dynamic-form #dynamicForm *ngIf="updateModal && updateData && updateQuestions.length > 0 && modalKey > 0" [questions]="updateQuestions"
    (sendData)="updateData?.testType === 'ASSESSMENT' ? updateAssessmentData($event) : updateSurveyData($event)">
  </app-dynamic-form>
  <p-messages [(value)]="messages" [enableService]="false"></p-messages>
</p-dialog>

<app-footer></app-footer>